import { baseApi } from "../baseApi";

export const serialApi = baseApi.injectEndpoints({
       endpoints: (builder) => ({
    serialnoList: builder.mutation({
       query: ({ start = 0, limit = 12, filters = [], fields = [] }) => ({
    url: `/api/resource/Serial No`,
    method: "GET",
    params: {
      filters: JSON.stringify(filters), // ✅ stringified filters array
      fields: JSON.stringify(
        fields.length > 0
          ? fields
          : [
             "name",
            "item_code",
            "warehouse",
            "company",
            "creation",
            "status",
            ]
      ), 
      order_by: "`tabSerial No`.`modified` desc",
      limit_start: start,
      limit_page_length: limit,
    },
  }),
     
    }),

    totalcountserialno: builder.mutation({
      query: () => ({
        url: `/api/method/frappe.client.get_count?doctype=Serial No`,
        method: "GET",
      }),
    }),
       Itemcodeserial: builder.mutation({
      query: () => ({
        url: `/api/resource/Item`,
        method: "GET",
      }),
    }),
    Companyserial: builder.mutation({
      query: () => ({
        url: `/api/resource/Company`,
        method: "GET",
      }),
    }),
     postCreateSerialNo: builder.mutation({
      query: (data) => ({
        url: `/api/resource/Serial No`,
        method: "post",
        body: data,
      }),
    }),
     postUpdateSerialNo: builder.mutation({
      query: ({ serial_no, ...payload }) => ({
        url: `/api/resource/Serial No/${serial_no}`,
        method: "PUT",
        body: payload,
      }),
    }),
      WorkOrderserial: builder.mutation({
      query: () => ({
        url: `/api/resource/Work Order`,
        method: "GET",
      }),
    })
  }),
});

export const {
  useSerialnoListMutation,
  useTotalcountserialnoMutation,
  useItemcodeserialMutation, 
  useCompanyserialMutation, 
   useWorkOrderserialMutation,
   usePostCreateSerialNoMutation,
   usePostUpdateSerialNoMutation,
} = serialApi;


